$(document).ready(function () {

    document.querySelectorAll(".filter-group-display__price-range").forEach((filterGroup) => {
        const rangeInput = filterGroup.querySelectorAll(".range-input input");
        const priceInput = filterGroup.querySelectorAll(".range-data input");
        const progress = filterGroup.querySelector(".slider .progress");
    
        let priceGap = 500;
    
        // Initialize progress bar positions
        let maxValue = parseInt(rangeInput[0].max);
        let progressMin = parseInt(rangeInput[0].value);
        let progressMax = parseInt(rangeInput[1].value);
    
        progressMin = (progressMin / maxValue) * 100;
        progressMax = 100 - ((progressMax / maxValue) * 100);
    
        progress.style.left = `${progressMin}%`;
        progress.style.right = `${progressMax}%`;
    
        // Handle price input changes
        priceInput.forEach((input) => {
            input.addEventListener("input", (e) => {
                let minPrice = parseInt(priceInput[0].value);
                let maxPrice = parseInt(priceInput[1].value);
    
                if (maxPrice - minPrice >= priceGap && maxPrice <= parseInt(rangeInput[1].max)) {
                    if (e.target.classList.contains("input-min")) {
                        rangeInput[0].value = minPrice;
                        progress.style.left = (minPrice / maxValue) * 100 + "%";
                    } else {
                        rangeInput[1].value = maxPrice;
                        progress.style.right = 100 - (maxPrice / maxValue) * 100 + "%";
                    }
                }
            });
        });
    
        // Handle range input changes
        rangeInput.forEach((input) => {
            input.addEventListener("input", (e) => {
                let minVal = parseInt(rangeInput[0].value);
                let maxVal = parseInt(rangeInput[1].value);
    
                if (maxVal - minVal < priceGap) {
                    if (e.target.classList.contains("range-min")) {
                        rangeInput[0].value = maxVal - priceGap;
                    } else {
                        rangeInput[1].value = minVal + priceGap;
                    }
                } else {
                    priceInput[0].value = minVal;
                    priceInput[1].value = maxVal;
                    progress.style.left = (minVal / maxValue) * 100 + "%";
                    progress.style.right = 100 - (maxVal / maxValue) * 100 + "%";
                }
            });
        });
    });    

    /* ------------------------------------------- */

    if ($('.main-collection .paginate').find('.page:not(.disable)').length > 0)
        $('.main-collection .paginate').css('display', 'flex');
    else
        $('.main-collection .paginate').css('display', 'none');

    $(document).on('click', '.main-collection .paginate a', function(e) {
        e.preventDefault();

        let newUrl = $(this).attr('href');
        
        filterCollection(newUrl);

        $('html, body').animate({
            scrollTop: $('.main-collection').offset().top - 50
        }, 0);

    });

    $('.clear-filter a').on('click', function(e) {
        e.preventDefault();

        let newUrl = curUrl;

        $('.filter-form input[type="checkbox"]').prop('checked', false);
        $('.filter-form input').val('');

        $('.sort-by.desktop select').val($('.sort-by.desktop select option:first').val());
        $('.sort-by.mobile select').val($('.sort-by.mobile select option:first').val());

        $('input[type="radio"][name="radio-sort"]').first().trigger('click');

        let maxValue = $('.range-min').attr('max');
        $('.range-min').val(0);
        $('.range-max').val(maxValue);
        $('.input-min').val(0);
        $('.input-max').val(maxValue);

        $('.slider .progress').css({
            'left': '0%',
            'right': '0%'
        });
        
        filterCollection(newUrl);
    });


    /* DESKTOP --------------------------------------------------- */

    $('.filter-form.desktop input').on('change', function() {
        $(".filter-form.desktop").trigger('submit');
        $('.sort-by.desktop select').val($('.sort-by.desktop select option:first').val());
    });

    $('.filter-form.desktop').submit(function (e) {
        e.preventDefault();

        let formData = $(this).serialize();
        let newUrl = curUrl+'?'+formData;
        
        filterCollection(newUrl);
    });

    $('.sort-by.desktop select').on('change', function() {
        let currentUrl = window.location.href;
        let url = new URL(currentUrl);

        url.searchParams.set("sort_by", $(this).val());

        let newUrl = url.toString();
        
        filterCollection(newUrl);
    });

    /* MOBILE --------------------------------------------------- */

    $('.filter-form.mobile input').on('change', function() {
        $(".filter-form.mobile").trigger('submit');
        $('.sort-by.mobile select').val($('.sort-by.mobile select option:first').val());
    });

    $('.filter-form.mobile').submit(function (e) {
        e.preventDefault();

        let formData = $(this).serialize();
        let newUrl = curUrl+'?'+formData;
        
        filterCollection(newUrl);
    });

    $('.toggle-filter').on('click', function() {
        $('.mobile-filter-container').css('display', 'flex');
        $('body').css('overflow-y', 'hidden');
    });

    $('.toggle-filter-close').on('click', function() {
        $('.mobile-filter-container').hide();
        $('body').css('overflow-y', 'visible');
    });
});

function filterCollection(newUrl) {

    $.ajax({
        type: "GET",
        url: newUrl,
        success: function(data) {

            //product count
            $('.item-found span').html($(data).find('.item-found span').html());

            //desktop update product list
            if ($(data).find('.product-list').find('.products').length > 0) {
                $('.product-list').html($(data).find('.product-list').html());
            }
            else {
                $('.product-list').html('<h3 class="pretitle-lg mt-bold f-black">No product found.</h3>');
            }

            //show hide pagination
            if ($('.paginate').find('.page:not(.disable)').length > 0)
                $('.paginate').css('display', 'flex');
            else
                $('.paginate').css('display', 'none');
        },
        error: function() {
            console.log("Error occurred while filtering products.");
        },
    });

    if (window.history && window.history.pushState) {
        window.history.pushState(null, null, newUrl);
    }
}

$('input[type="radio"][name="radio-sort"]').change(function() {
    let selectedValue = $(this).val();
    $(`.sort-by.mobile select option`).removeAttr('selected');
    $(`.sort-by.mobile select option[value="${selectedValue}"]`).attr('selected', 'selected');

    let currentUrl = window.location.href;
    let url = new URL(currentUrl);

    url.searchParams.set("sort_by", selectedValue);

    let newUrl = url.toString();
    
    filterCollection(newUrl);

    if ($(this).is(':checked')) {
        let spanHtml = $(this).next('span').html();
        $('#heading-sortBy button span').html(`Sort By: ${spanHtml}`);
    }
});